module.exports = __webpack_public_path__ + "img/badge_gaming.17380dbc.jpg";